import React, { ChangeEvent } from 'react';
import styles from './Checkbox.module.scss';
import clsx from 'clsx';
import MinusIcon from 'assets/icons/minus.svg?react';

type OwnProps = {
  helperText?: string;
  containerClassName?: string;
  inputClassName?: string;
  textClassName?: string;
  isChecked?: boolean;
  disabled?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  actionText?: string;
  testId?: string;
  textTestId?: string;
  halfChecked?: boolean;
  actionTextClassName?: string;
  checkBoxClassName?: string;
};

export const Checkbox = (props: OwnProps) => {
  const {
    containerClassName,
    inputClassName,
    textClassName,
    isChecked,
    helperText,
    disabled,
    onChange,
    actionText,
    testId,
    textTestId,
    halfChecked,
    actionTextClassName,
    checkBoxClassName,
  } = props;

  const halfCheckedBox = !isChecked && halfChecked;

  return (
    <div className={clsx(styles.rowContainer, containerClassName)}>
      {helperText && (
        <div
          className={clsx(
            styles.checkboxHelperText,
            textClassName,
            disabled && styles.disabled,
          )}
        >
          {helperText}
        </div>
      )}
      {actionText && (
        <label
          data-test-id={textTestId}
          className={clsx(styles.text, actionTextClassName)}
          htmlFor={actionText}
        >
          {actionText}
        </label>
      )}
      <label
        className={clsx(
          styles.checkbox,
          disabled && styles.disabled,
          checkBoxClassName,
        )}
      >
        <input
          onChange={onChange}
          disabled={disabled}
          className={styles.input}
          checked={isChecked}
          type="checkbox"
          id={actionText}
          data-test-id={testId}
        />
        <span
          className={clsx(
            styles.overlay,
            halfCheckedBox && styles.halfChecked,
            inputClassName,
          )}
        />
        {halfCheckedBox && <MinusIcon className={styles.minus} />}
      </label>
    </div>
  );
};
